import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGroeneHaag = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M35 21.5a2.48 2.48 0 0 0-1.26-2.16 1.5 1.5 0 0 0 .26-.84 1.47 1.47 0 0 0-.54-1.14 2 2 0 0 0 0-2.72A1.47 1.47 0 0 0 34 13.5a1.5 1.5 0 0 0-.39-1A1.49 1.49 0 0 0 32.5 10a1.5 1.5 0 0 0-.56.11 1.49 1.49 0 0 0-2.88 0 1.5 1.5 0 0 0-.56-.11 1.5 1.5 0 0 0-1 .39 1.5 1.5 0 0 0-1-.39 1.5 1.5 0 0 0-.68.17A2 2 0 0 0 22 11v.28A2 2 0 0 0 21 13a2 2 0 0 0 .69 1.5 2 2 0 0 0-.25 2.74 2.49 2.49 0 0 0-.18 4.42 1.5 1.5 0 0 0-.26.84 1.47 1.47 0 0 0 .54 1.14 2 2 0 0 0 .15 2.86 2 2 0 0 0-.27 2.71A1 1 0 0 0 21 30a1 1 0 0 0 1 1h11a1 1 0 0 0 .41-1.91A2.47 2.47 0 0 0 34 27.5a2.5 2.5 0 0 0-.7-1.73 1.5 1.5 0 0 0 .44-2.11A2.48 2.48 0 0 0 35 21.5"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28 15v14h-1V15z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m29.854 19.354-2 2-.708-.707 2-2zM25.854 23.647l2 2-.708.707-2-2zM25.854 16.647l2 2-.708.707-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M20 21.5a2.48 2.48 0 0 0-1.26-2.16 1.5 1.5 0 0 0 .26-.84 1.47 1.47 0 0 0-.54-1.14 2 2 0 0 0 0-2.72A1.47 1.47 0 0 0 19 13.5a1.5 1.5 0 0 0-.39-1A1.49 1.49 0 0 0 17.5 10a1.5 1.5 0 0 0-.56.11 1.49 1.49 0 0 0-2.88 0 1.5 1.5 0 0 0-.56-.11 1.5 1.5 0 0 0-1 .39 1.5 1.5 0 0 0-1-.39 1.5 1.5 0 0 0-.68.17A2 2 0 0 0 7 11v.28A2 2 0 0 0 6 13a2 2 0 0 0 .69 1.5 2 2 0 0 0-.25 2.74 2.49 2.49 0 0 0-.18 4.42 1.5 1.5 0 0 0-.26.84 1.47 1.47 0 0 0 .54 1.14 2 2 0 0 0 .15 2.86 2 2 0 0 0-.27 2.71A1 1 0 0 0 6 30a1 1 0 0 0 1 1h11a1 1 0 0 0 .41-1.91A2.47 2.47 0 0 0 19 27.5a2.5 2.5 0 0 0-.7-1.73 1.5 1.5 0 0 0 .44-2.11A2.48 2.48 0 0 0 20 21.5"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M13 14v15h-1V14z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m14.854 23.354-2 2-.708-.707 2-2zM14.854 18.354l-2 2-.708-.707 2-2zM10.854 25.647l2 2-.708.707-2-2zM10.854 14.647l2 2-.708.707-2-2z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGroeneHaag);

export default ForwardRef;
